<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">
        抓拍详情(区间测速)
      </v-toolbar-title>
    </v-app-bar>
    <v-content style="background: #eee;">
      <v-container style="font-size:0.9rem;padding:0.9rem 1.1rem 5rem;color:rgba(33, 33, 33, 0.9);">
        <div v-if="loading" style="margin-top:10rem;">
          <LoadingText />
        </div>
        <div v-else>
           <div>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">车牌</v-col>
              <v-col :cols="9">
                <span>{{camImage.CAR_NO}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">A点图片</v-col>
              <v-col style="padding:6px;margin-top:0.29rem;" :cols="9">
                <div style="width:200px;height:200px;">
                  <viewer :images="[camImage.A_IMG_URL]">
                    <img
                      :src="camImage.A_IMG_URL"
                      :data-original="camImage.A_IMG_URL"
                      onError='this.src="/res/default_img.jpg";this.onerror=null;'
                      alt="A"
                      class="img-rounded"
                      style="width:200px;height:200px;border-radius:5px;border:1px solid #f2f2f2;"
                    />
                  </viewer>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">A地点</v-col>
              <v-col :cols="9">
                <span>{{camImage.A_CAM_NAME}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">A点抓拍时间</v-col>
              <v-col :cols="9">
                <span>{{getMsgTimeFormat(camImage.A_CAPTURE_TIME)}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">B点图片</v-col>
              <v-col style="padding:6px;margin-top:0.29rem;" :cols="9">
                <div style="width:200px;height:200px;">
                  <viewer :images="[camImage.B_IMG_URL]">
                    <img
                      :src="camImage.B_IMG_URL"
                      :data-original="camImage.B_IMG_URL"
                      onError='this.src="/res/default_img.jpg";this.onerror=null;'
                      alt="B"
                      class="img-rounded"
                      style="width:200px;height:200px;border-radius:5px;border:1px solid #f2f2f2;"
                    />
                  </viewer>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">B地点</v-col>
              <v-col :cols="9">
                <span>{{camImage.B_CAM_NAME}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">B点抓拍时间</v-col>
              <v-col :cols="9">
                <span>{{getMsgTimeFormat(camImage.B_CAPTURE_TIME)}}</span>
              </v-col>
            </v-row>

            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">速度(hm/k)</v-col>
              <v-col :cols="9">
                <span>{{camImage.SPEED}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">限速值</v-col>
              <v-col :cols="9">
                <span>{{camImage.SPEED_LIMIT}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">超速率</v-col>
              <v-col :cols="9">
                <span>{{camImage.SUPER_SPEED}}%</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">所属部门</v-col>
              <v-col :cols="9">
                <span>{{camImage.US_DEPT}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">联系人</v-col>
              <v-col :cols="9">
                <span>{{camImage.US_TEXT}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">电话</v-col>
              <v-col :cols="9">
                <span>{{camImage.US_TEL}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">车型</v-col>
              <v-col :cols="9">
                <span>{{camImage.US_CAR_TYPE}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">车牌颜色</v-col>
              <v-col :cols="9">
                <span>{{camImage.CAR_NO_COLOR}}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="3" style="color:#9e9e9e;">车辆颜色</v-col>
              <v-col :cols="9">
                <span>{{camImage.US_CAR_COLOR}}</span>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-container>
    </v-content>
  </v-app>

</template>

<script>
import LoadingText from '../../components/LoadingText'
export default {
  components: { LoadingText },
  props: {
  },
  data() {
    return {
      loading: true,
      notify_id: 0,
      camImage: {}
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    if (that.$route.query.notify_id) {
      that.notify_id = that.$route.query.notify_id
    }
    that.init()
  },
  created() {
  },
  activated() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    async init() {
      var that = this
      var res = await that.$api.bz.getCarSpeedABDetail({ notify_id: that.notify_id })
      if (!res.success) {
        console.log('获取数据失败', res);
        that.loading = false
        return;
      }
      that.camImage = res.data
      that.loading = false
    },
    // 格式化时间显示
    getMsgTimeFormat(time) {
      var that = this
      var mt = that.$moment(time)
      var tv = mt.format('YYYY-MM-DD')
      var now = that.$moment(new Date()).format('YYYY-MM-DD')
      if (tv < now) {
        var zt = that.$moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        if (zt === tv) {
          return mt.format('昨天 HH:mm')
        }
        return mt.format('YYYY-MM-DD HH:mm')
      }
      return mt.format('今天 HH:mm')
    }
  }
}
</script>

<style scoped>

</style>

